import React from 'react';
import { ReactComponent as RawLogo } from '../../assets/caja_detallada.svg';

const DropLogo = ({ size = 24, title = 'Drop Hack', ...rest }) => (
  <div style={{ width: size, height: size, display: 'flex', flexShrink: 0 }} {...rest}>
    <RawLogo
      width="100%"
      height="100%"
      aria-label={title}
      style={{ display: 'block', color: 'var(--logo-color)' }}
    />
  </div>
);

export default DropLogo;
